import { ExcelDownloadDefinition } from "@lib/ShiOneClient";
import { LIFECYCLE_CATEGORY_LABELS } from "shared-ui/src/components/lifecycle-management/buildLifecycleCategoryFilterCategory";

export const PICKLIST_LABELS: Record<string, string> = {
  axAccountNumber: "Account",
  manufacturer: "Manufacturer",
  eventType: "Event Type",
  status: "Status",
  strategy: "Strategy",
  source: "Source",
  assignedTo: "Assigned To",
  accountExecutive: "Account Executive",
  revenueRange: "Previous Purchase Cost",
  ...LIFECYCLE_CATEGORY_LABELS,
};

export const ASSET_LIFECYCLE_QUERY_KEYS = {
  timeline: "asset-lifecycle-management-timeline-data",
  grid: "asset-lifecycle-management-grid-data",
  picklist: "asset-lifecycle-management-picklist",
  drawerOrders: "asset-lifecycle-management-drawer-orders-data",
  drawerEventUpdate: "asset-lifecycle-management-drawer-event-update",
  drawerLineItems: "asset-lifecycle-management-drawer-line-items-data",
  customerOwners: "asset-lifecycle-management-customer-owners",
  importAccounts: "asset-lifecycle-management-import-accounts",
  eventByIdentifier: "asset-lifecycle-management-event-by-identifier",
} as const;

// The generated ShiOneClient expects class instances with methods like toJSON(),
// but defining them as plain objects here is cleaner and easier to read.
// We convert them to proper ExcelDownloadDefinition instances in the hook
// when we call the API.
export const LIFECYCLE_EXPORT_GRID_DEFINITIONS: ExcelDownloadDefinition[] = [
  { header: "Manufacturer", dataField: "manufacturer" },
  { header: "Event Type", dataField: "eventType" },
  { header: "Event Date", dataField: "eventDate" },
  { header: "Covered Assets", dataField: "coveredItems" },
  { header: "Status", dataField: "status" },
  { header: "Previous Purchase Cost", dataField: "previousPurchaseCost" },
  { header: "Purchase Timeframe", dataField: "purchaseTimeframe" },
  { header: "Strategy", dataField: "strategy" },
  { header: "Notes", dataField: "customerFacingNotes" },
] as ExcelDownloadDefinition[];

export const LIFECYCLE_EXPORT_LINE_ITEM_GRID_DEFINITIONS: ExcelDownloadDefinition[] =
  [
    { header: "Unique ID", dataField: "assetId" },
    { header: "Serial Number", dataField: "serialNumber" },
    { header: "Manufacturer", dataField: "manufacturer" },
    { header: "Product", dataField: "product" },
    { header: "Order Number", dataField: "orderNumber" },
    { header: "Part Number", dataField: "orderLineItem" },
    { header: "Event Date", dataField: "eventDate" },
    { header: "Event Type", dataField: "eventType" },
    { header: "End Date", dataField: "maintenanceEndDate" },
    { header: "Status", dataField: "status" },
    { header: "Previous Purchase Cost", dataField: "previousPurchaseCost" },
    { header: "Quantity", dataField: "quantity" },
    { header: "Strategy", dataField: "strategy" },
    { header: "PO#", dataField: "poNumber" },
  ] as ExcelDownloadDefinition[];

export const AssetLifecycleManagementDrawerTabNames = [
  "Event",
  "Orders",
  "Assets",
  "Activity",
] as const;
export type AssetLifecycleManagementDrawerTabName =
  (typeof AssetLifecycleManagementDrawerTabNames)[number];

export const AssetLifecycleManagementDrawerTabHeaders: Record<
  AssetLifecycleManagementDrawerTabName,
  { header: string; subheader: string }
> = {
  Event: {
    header: "Asset Lifecycle Management Details",
    subheader: "Lifecycle Event",
  },
  Orders: {
    header: "Asset Lifecycle Management Details",
    subheader: "Lifecycle Event",
  },
  Assets: {
    header: "Asset Lifecycle Management Details",
    subheader: "Lifecycle Event",
  },
  Activity: {
    header: "Asset Lifecycle Management Details",
    subheader: "Lifecycle Event",
  },
};

export enum ACTIVITY_CHANGE {
  Added = "added",
  Removed = "removed",
  Changed = "changed",
  Reverted = "reverted",
}

/** Open state of the event-date confirmation, when the host routes it. */
export interface LifecycleEventDateDialogControls {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const LIFECYCLE_MANAGEMENT_EVENT_DATA_SOURCE = {
  ManuallyCreated: "Custom",
  Imported: "Imported",
  ShiInvoice: "SHI",
} as const;
